export default __webpack_public_path__ + "static-front/media/AccountCheckIcon.ef50ac6c.svg";